import { render, staticRenderFns } from "./ShopsCreation.vue?vue&type=template&id=b93ca2d0"
import script from "./ShopsCreation.vue?vue&type=script&lang=js"
export * from "./ShopsCreation.vue?vue&type=script&lang=js"
import style0 from "./ShopsCreation.vue?vue&type=style&index=0&id=b93ca2d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports